import React, { useCallback, useEffect, useState } from "react";

const DialogContext = React.createContext();

const Dialog = ({ dialog, unSetDialog, size = "default" }) => {
  const getSizeClasses = () => {
    switch (size) {
      case "large":
        return "w-11/12 max-w-3xl";
      case "extra-large":
        return "w-11/12 max-w-5xl";
      case "full":
        return "w-11/12 max-w-full";
      default:
        return "w-11/12 max-w-1xl";
    }
  };
  useEffect(() => {
    const bind = (e) => {
      if (e.keyCode !== 27) {
        return;
      }

      if (
        document.activeElement &&
        ["INPUT", "SELECT"].includes(document.activeElement.tagName)
      ) {
        return;
      }

      unSetDialog();
    };

    document.addEventListener("keyup", bind);
    return () => document.removeEventListener("keyup", bind);
  }, [dialog, unSetDialog]);

  return (
    // replace all the classes etc
    <div
      className="modal modal-open modal-middle"
      onClick={(e) => {
        if (e.currentTarget !== e.target) return;
        unSetDialog();
      }}
    >
      <div className={`modal-box ${getSizeClasses()}`}>
        {dialog}
        <button
          type="button"
          className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
          onClick={unSetDialog}
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export const DialogProvider = (props) => {
  const [dialog, setDialog] = useState();
  const [dialogSize, setDialogSize] = useState("default");
  
  const unSetDialog = useCallback(() => {
    setDialog();
    setDialogSize("default");
  }, [setDialog]);

  const setDialogWithSize = useCallback((dialogComponent, size = "default") => {
    setDialog(dialogComponent);
    setDialogSize(size);
  }, []);

  return (
    <DialogContext.Provider value={{ unSetDialog, setDialog, setDialogWithSize }} {...props}>
      {props.children}
      {dialog && <Dialog dialog={dialog} unSetDialog={unSetDialog} size={dialogSize} />}
    </DialogContext.Provider>
  );
};

export const useDialog = () => {
  const context = React.useContext(DialogContext);
  if (context === undefined) {
    throw new Error("useDialog must be used within a UserProvider");
  }

  return context;
};
